export const COST_FILE_TEMPLATE_CREATOR_STEPS = {
  START: 'start',
  MAP: 'map',
  VALIDATE: 'validate',
} as const;
